import { useAPIQuery } from "../../../hooks/useAPIQuery";
import { Table } from "@dev2_techwalnut/tw-react-crud-dashlite";
import React, { useState } from "react";
import { NavLink, useNavigate, useSearchParams } from "react-router-dom";
import Error from "../../ErrorPages/Error";
import { VARIABLES } from "../../Constant";
import moment from "moment/moment";
import Swal from "sweetalert2";
import secureLocalStorage from "react-secure-storage";
import POSlip from "../../slips/POSlip";

const PurchaseOrder = () => {
    const privileges = secureLocalStorage.getItem("privileges");
    const delay_time = VARIABLES.delayTime;
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const initialEntries = Number(searchParams.get("entries")) || 10;
    const initialPage = Number(searchParams.get("page")) || 1;
    const initialQueries = searchParams.get("q")?.split(",") || [];
    const initialColumns = searchParams.get("c")?.split(",") || [];

    const [entries, setEntries] = useState(initialEntries);
    const [pageIndex, setPageIndex] = useState(initialPage - 1);
    const [globalFilterValue, setGlobalFilterValue] = useState("");
    const [columnFilterKey, setColumnFilterKey] = useState("");
    const [columnFilterValue, setColumnFilterValue] = useState("");
    const [sorting, setSorting] = useState([]);
    const TypeMasterQuery = useAPIQuery({
        key: "api/type-master",
        endpoint: "/api/type-master/",
    });

    const TypeMasterQueryData = TypeMasterQuery.useFetch({
        params: {
            q: "PO Declaration",
            c: "category",
        },
    });

    const company_pan = TypeMasterQuery.useFetch({
        params: {
            q: "Company PAN",
            c: "name",
        },
    });

    const {
        useFetch: useFetchPurchaseOrders,
        useDelete: useDeletePurchaseOrder,
    } = useAPIQuery({
        key: "purchase-order",
        endpoint: "/api/purchase-order/",
    });
    const {
        data: purchaseOrders,
        isLoading: purchaseOrdersLoading,
        isError: errorLoadingPurchaseOrders,
        isFetching: fetchingPurchaseOrders,
    } = useFetchPurchaseOrders({
        params: {
            entries: entries,
            page_no: pageIndex + 1,
            q: globalFilterValue !== "" ? globalFilterValue : columnFilterValue,
            c: globalFilterValue === "" ? columnFilterKey : "",
            sort:
                sorting &&
                sorting
                    ?.map((item) => (item?.desc ? `-${item?.id}` : item?.id))
                    ?.join(","),
        },
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const { mutate: deletePurchaseOrder } = useDeletePurchaseOrder({
        successMessageFromServer: true,
        errorMessageFromServer: true,
    });
    const { useFetch: useFetchGeneric } = useAPIQuery({
        key: "api/generic",
        endpoint: "/api/generic/",
    });

    const { data: genericData } = useFetchGeneric({
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const columns = [
        {
            accessor: "po_number",
            header: "Purchase Order",
            filterable: true,
            filterType: "text",
            sortable: true,
        },
        {
            accessor: "supplier_name",
            header: "Supplier",
            cell: (row) => <>{row?.supplier?.supplier_name}</>,
            filterable: true,
        },
        {
            accessor: "item_name",
            header: "Item",
            cell: (row) => <>{row?.item?.item_name}</>,
            filterable: true,
        },
        {
            accessor: "delivery_date",
            header: "Delivery Date",
            cell: (row) => (
                <>{moment(row?.delivery_date).format("DD-MM-YYYY")}</>
            ),
            sortable: true,
        },
        {
            accessor: "quantity",
            header: "Quantity",
        },
        {
            accessor: "amount",
            header: "Amount",
        },
        privileges.includes("print_purchase_order")
            ? {
                  accessor: "print",
                  header: "Print",
                  cell: (row) => (
                      <POSlip
                          row={row}
                          declarations={
                              TypeMasterQueryData.data?.results?.data?.map(
                                  (d) => d?.value ?? ""
                              ) ?? []
                          }
                          company_pan={
                              company_pan?.data?.results?.data?.[0]?.value ?? ""
                          }
                      />
                  ),
              }
            : null,
    ].filter(Boolean);

    const handleGlobalFilterChange = (value) => {
        const q = value?.trim() || "";
        if (q !== "") {
            setGlobalFilterValue(q);
            setColumnFilterKey("");
            setColumnFilterValue("");
            setSearchParams((searchParams) => {
                searchParams.set("q", q);
                searchParams.delete("c");
                return searchParams;
            });
        } else if (q === "") {
            setGlobalFilterValue("");
            setSearchParams((searchParams) => {
                searchParams.delete("q");
                return searchParams;
            });
        }
    };

    const handleColumnFilterChange = (value) => {
        const q = value.map((val) => val.value?.trim() || "").join(",");
        const c = value.map((val) => val.id).join(",");
        if (q !== "" && c !== "") {
            setGlobalFilterValue("");
            setColumnFilterKey(c);
            setColumnFilterValue(q);
            setSearchParams((searchParams) => {
                searchParams.set("q", q);
                searchParams.set("c", c);
                return searchParams;
            });
        } else if (q === "" && c === "") {
            setColumnFilterKey("");
            setColumnFilterValue("");
            setSearchParams((searchParams) => {
                searchParams.delete("q");
                searchParams.delete("c");
                return searchParams;
            });
        }
    };

    const handlePagination = (value) => {
        setSearchParams((searchParams) => {
            searchParams.set("entries", value.pageSize);
            searchParams.set("page", value.pageIndex + 1);
            return searchParams;
        });
        setPageIndex(value.pageIndex);
        setEntries(value.pageSize);
    };
    const handleEditRow = (row) => {
        navigate(`/edit-purchase-order`, { state: { data: row?.original } });
    };
    const handleDelteRow = (row) => {
        Swal.fire({
            text: "Are you sure? You will not be able to recover this data!",
            showDenyButton: true,
            confirmButtonText: "Yes",
            denyButtonText: `No, cancel!`,
        }).then((result) => {
            if (result.isConfirmed) {
                deletePurchaseOrder({
                    id: row?.original?.id,
                });
            }
        });
    };
    const handleSortingChnage = (value) => {
        console.log(value);
        setSorting(value);
    };
    if (errorLoadingPurchaseOrders) return <Error />;
    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content d-flex">
                        <h3 className="nk-block-title page-title">
                            Purchase Order
                        </h3>
                    </div>
                    {/* To-Do: Add privilege */}
                    {privileges.includes("purchase_order_create") && (
                        <div className="nk-block-head-content">
                            <NavLink
                                to="/create-purchase-order"
                                className="toggle btn btn-icon btn-primary d-md-none"
                                id="button-button-create-purchase-order"
                            >
                                <em className="icon ni ni-plus"></em>
                            </NavLink>

                            <NavLink
                                to="/create-purchase-order"
                                className="toggle btn btn-primary d-none d-md-inline-flex"
                                id="button-button-create-purchase-order"
                            >
                                <em className="icon ni ni-plus"></em>
                                <span>Create Purchase Order</span>
                            </NavLink>
                        </div>
                    )}
                </div>
            </div>
            <Table
                data={purchaseOrders ? purchaseOrders?.results?.data : []}
                columns={columns}
                isLoading={purchaseOrdersLoading || fetchingPurchaseOrders}
                pagination
                pageIndex={pageIndex}
                pageSize={entries}
                rowCount={purchaseOrders ? purchaseOrders?.count : 0}
                selectRows={false}
                editRows={
                    privileges.includes("purchase_order_update") ? true : false
                }
                deleteRows={
                    privileges.includes("purchase_order_delete") ? true : false
                }
                defaultGlobalSearchValue={
                    initialQueries.length > 0 && initialColumns.length <= 0
                        ? initialQueries[0]
                        : undefined
                }
                defaultColumnFiltersValue={
                    initialQueries.length > 0 && initialColumns.length > 0
                        ? initialColumns.map((column, index) => ({
                              id: column,
                              value: initialQueries?.[index] ?? "",
                          }))
                        : undefined
                }
                onPaginationChange={handlePagination}
                onGlobalFilterChange={handleGlobalFilterChange}
                onColumnFilterChange={handleColumnFilterChange}
                onRowEdit={handleEditRow}
                onRowDelete={handleDelteRow}
                onSortingChange={handleSortingChnage}
            />
        </>
    );
};

export default PurchaseOrder;
